<template>
  <header :class="headerColor">
    <div class="header-inner">
      <template v-if="isShowOnlySearchInput">
        <v-layout class="xs-4" fixed height="50px">
          <Logo :color="logoColor" :disabled="isLogoLinkUnClickable" :is-lefiling="isLeFILING" />
        </v-layout>

        <v-flex v-if="isShowSearchInput" xs4 class="overflow-hidden">
          <SearchInputButton @search="searchJoubun" />
        </v-flex>

        <v-flex xs4 h-100 class="overflow-hidden" v-if="isShowUserMenu">
          <div class="menu-wrapper">
            <div class="overflow-hidden">
              <UserPropertyMenu />
            </div>
            <div style="width: auto;">
              <v-flex class="header-menu">
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <a v-on="on" @click="openHelpCenter('top')" style="width: 50px" class="text-center">
                      <IconButton color="#fff">help</IconButton>
                    </a>
                  </template>
                  <span>ヘルプセンターはこちら</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <a v-on="on" @click="openHelpCenter('support')" style="width: 50px" class="text-center">
                      <img :src="$cdnEndpoint + 'img/header/icon_mail.png'" height="22px" />
                    </a>
                  </template>
                  <span>お問い合わせはこちら</span>
                </v-tooltip>
                <UserSettingsMenu />
              </v-flex>
            </div>
          </div>
        </v-flex>
        <v-flex xs4 h-100 class="overflow-hidden" v-if="!isShowUserMenu"> </v-flex>
      </template>
      <template v-else>
        <v-flex v-if="isShowSearchInput">
          <SearchInputButton @search="searchJoubun" />
        </v-flex>
      </template>
    </div>
  </header>
</template>

<script>
import Logo from '@/components/_atoms/Logo';
import Button from '@/components/_atoms/buttons/Button.vue';
import IconButton from '@/components/_atoms/buttons/IconButton';
import SpanText from '@/components/_atoms/SpanText.vue';
import Icon from '@/components/_atoms/Icon.vue';
import SearchInputButton from '@/components/_molecules/SearchInputButton.vue';

import UserPropertyMenu from '@/components/_organisms/UserPropertyMenu.vue';
import UserSettingsMenu from '@/components/_organisms/UserSettingsMenu.vue';

export default {
  name: 'Header',
  components: {
    Logo,
    IconButton,
    Button,
    Icon,
    SpanText,
    UserPropertyMenu,
    SearchInputButton,
    UserSettingsMenu
  },
  computed: {
    logoColor() {
      const page = this.$route.name;

      if (page === 'LoginForCloudsignReview' || this.isCloudsignReview || this.isCloudsignReviewLogoutStatus) {
        return 'cloudsign_review';
      }

      switch (page) {
        case 'ContractDiff':
          return 'black';
        case 'ReviewContract':
          return 'white';
        case 'SplitUserTemplate':
          return 'white';
        default:
          return 'brand';
      }
    },
    headerColor() {
      const page = this.$route.name;

      if (page === 'LoginForCloudsignReview' || this.isCloudsignReview || this.isCloudsignReviewLogoutStatus) {
        return 'header-cloudsign-review';
      }

      switch (page) {
        case 'ContractDiff':
          return 'header-brand-white';
        case 'ReviewContract':
          return 'header-brand';
        case 'SplitUserTemplate':
          return 'header-brand';
        default:
          return 'header-brand-black';
      }
    },
    isCloudsignReview: function() {
      if (!this.isLoggedIn) return false;
      return this.$store.state.auth.isDispPoweredLabel;
    },
    isCloudsignReviewLogoutStatus() {
      // LeCHECKのログイン画面のときはヘッダーはLeCHECKになるようにする
      const page = this.$route.name;
      if (page === 'Login') {
        return false;
      }
      return localStorage.getItem('isCloudsignReview') === 'true';
    },
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn;
    },
    isShowSearchInput() {
      const showSearchInputRouteName = ['ContractList', 'ReviewContract', 'PrioritySettings', 'ClientList', 'ContractTagList'];
      return this.isLoggedIn && showSearchInputRouteName.includes(this.$route.name);
    },
    isShowUserMenu() {
      const showUserMenuRouteName = ['ContractList', 'PrioritySettings', 'CabinetMaster', 'ClientList', 'ContractTagList'];
      return this.isLoggedIn && showUserMenuRouteName.includes(this.$route.name);
    },
    isShowOnlySearchInput() {
      const hideLogoRouteName = ['ReviewContract'];
      if (hideLogoRouteName.includes(this.$route.name)) {
        return this.$vuetify.breakpoint.width > 960;
      }
      return true;
    },
    isLogoLinkUnClickable() {
      const unLogoClickableRouteName = ['ReviewContract', 'ContractDiff', 'SplitUserTemplate'];
      return unLogoClickableRouteName.includes(this.$route.name);
    },
    isLeFILING: function() {
      return this.$route.name === 'LoginForLeFILING';
    }
  },
  methods: {
    searchJoubun(searchKeyword) {
      this.$store.dispatch('searchJoubun/openWindow', searchKeyword);
    },
    openHelpCenter(retURL) {
      const routeData = this.$router.resolve({
        name: 'HelpCenter',
        query: { page: retURL }
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style scoped>
header {
  position: fixed;
  width: 100%;
  z-index: 99;
  height: 50px;
  color: #fff;
  font-family: 'Noto Sans', sans-serif;
}
.header-brand {
  background-color: #5957c4;
}
.header-brand-black {
  background-color: #000;
}
.header-brand-white {
  background-color: #fff;
}
.header-cloudsign-review {
  background-color: #0d64c9;
}
a {
  text-decoration: none;
  color: white;
}
ul {
  padding: 0;
}
.header-inner {
  height: 100%;
  margin: 0 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.header-menu {
  height: 100%;
  display: flex;
}
.header-menu a {
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-menu a:hover {
  background-color: #252525;
}
.header-cloudsign-review .header-menu a:hover {
  background-color: #1571d7;
}

.menu-wrapper {
  display: flex;
  height: 100%;
  justify-content: end;
}

.header-button {
  height: 100%;
  margin: 0;
  text-transform: none;
}

.header-button::before {
  background-color: transparent;
}
.account_card {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_organisms/Header.vue